<template>
    <div>
        
        <!-- Modal for add a lamp to a monitoring zone -->
        <AddToMonitoringZone :lamp="lampToAdd" v-model="modalAddToZone" :alerts="alerts" @hide="resetAddToZone"/> 

        <nav-bar-main></nav-bar-main> 

        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>


        <!-- <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div> -->
        <ErrorBanner />

        <Loader />

        <div v-if="plantDetails != null && unitsDetails != null" class="animated fadeIn container-fluid">
 
            <!-- alert per feedback dei comandi -->
            <b-row class="alert-feeback-command">
                <b-col lg="12" md="12">
                    <b-alert v-for="(alert, indexA) in alerts" :show="alert.timeLeft"
                        v-bind:key="indexA" :variant="alert.state" dismissible fade
                        @dismissed="alert.timeLeft = 0" @dismiss-count-down="alert.countDownChanged">
                        <div>
                            <i v-if="alert.state == 'danger'"
                                class="fa fa-1x fa-exclamation-circle mr-2"></i>
                            <i v-if="alert.state == 'success'"
                                class="fa fa-1x fa-check-circle mr-2"></i>
                            <div class="pb-3" style="display:inline; font-size:13px; height:15px;">
                                {{ alert.msg }}</div>
                        </div>
                    </b-alert>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                   <b-col sm="12" md="2" offset-md="10">
                    <b-input-group>
                        <b-form-input type="text" :placeholder="$t('planimetry.search_placeholder')" v-model="highlightedLamp"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary" @click="evidenzia()"><i class="fa fa-search"></i> </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>

            <b-row class="mt-4">
                <b-col v-for="(ambiente,index) in ambienti" :key="'amb-'+index"  xl="4" lg="6" md="12" sm="12">
                    <b-card border-variant="primary" body-class="nopad">

                        <div slot="header">
                            {{ambiente.name}}
                            <div class="card-header-actions">
                                <b-link href="#" class="card-header-action btn-close" @click="eliminaAmbiente(ambiente,index)" >
                                    <i class="fa fa-trash"></i>
                                </b-link>
                            </div>
                        </div>

                        <div class="imgDiv" :id="'imgDiv'+index">
                            <img v-for="(lampInfo) in ambiente.lamps" :tipo="lampInfo.tipo" :id="'ambdot-'+ambiente.id+'-'+lampInfo.id+picLoaded['pic'+ambiente.id]" :key="'linfo-'+ambiente.id+'-'+lampInfo.id+'-'+picLoaded['pic'+ambiente.id]" :src="'/img/dot_' + lampInfo.status + '_' + lampInfo.tipo +'.png'" :class="{'dotImg':true, 'dotImgEmergency': lampInfo.emergency=='on', 'dotImgHighlight': lampInfo.id == highlightedLamp.toUpperCase()}"  v-bind:style="{marginLeft: pos(index,lampInfo,ambiente.id).x, marginTop:pos(index,lampInfo,ambiente.id).y}"  />
                            <!-- <img v-for="(lampInfo) in ambiente.lamps" :id="'ambdot-'+ambiente.id+'-'+lampInfo.id+picLoaded['pic'+ambiente.id]" :key="'linfo-'+ambiente.id+'-'+lampInfo.id+'-'+picLoaded['pic'+ambiente.id]" :src="'/img/dot_' + lampInfo.status+'.png'" :class="{'dotImg':true, 'dotImgHighlight': lampInfo.id == highlightedLamp.toUpperCase()}"   v-bind:style="{marginLeft: pos(index,lampInfo,ambiente.id).x, marginTop:pos(index,lampInfo,ambiente.id).y}"  /> -->
                            <b-img :src="imageUrl(ambiente.id)" fluid @click="apriModal(index)" @load="picReady(ambiente.id)" />
                            <div v-if="$store.getters.isProExpired" style="background-color: rgba(0,0,0,0.8); position:absolute; top: 0px; left:0px; right:0px; bottom: 0px" ></div>
                        </div>
                    </b-card>
                </b-col>
                <b-col>
                    <b-button v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'" @click="showModalDisclaimer()" ><span style="font-size:40px; font-weight: bold">+</span><br/>{{this.$t("navbar_dispositivi.add_"+ section)}}</b-button>
                </b-col>
            </b-row>
            <div style="height: 80px">&nbsp;</div>
        </div>

            <b-modal v-if="currentAmbiente != null && currentAmbiente.name != null" 
                id="modal-ambiente" 
                :title="'Dettaglio ' + currentAmbiente.name" 
                modal-class="modal-fullscreen" 
                :hide-footer="true" 
                @show="apertoDettaglioMappa"
                no-close-on-backdrop
                no-close-on-esc>
            
            <template v-slot:modal-header="{ close }">
                <b-row class="ModalPlanimetrieHeader">
                    <b-col cols="auto"><h5>{{$t('config_cu_modal.details')}}</h5></b-col>
                    <b-col cols="7">
                        <span v-if="updatingName">{{currentAmbiente.name}}</span>
                        <b-form-input v-if="!updatingName" v-model="currentAmbiente.name" :placeholder="$t('scenario.set_name')"></b-form-input>
                    </b-col>
                    <b-col cols="4">
                        <b-button @click="salvachiudiDettaglioMappa($event)" variant="light" class="mr-1"><span class="typo-label" :content="$t('planimetry.save')" v-tippy="{ placement : 'bottom',  arrow: true}"><i class="fa fa-save" style="color:#0090CD"></i></span></b-button>
                        <b-button @click="generaPdfMappa()" variant="light"><span class="typo-label" :content="$t('planimetry.download')" v-tippy="{ placement : 'bottom',  arrow: true}"><i class="fa fa-download" style="color:#0090CD"></i></span></b-button>                    
                    </b-col>
                    <b-col cols="1" class="float-right">
                        <button class="close close-x" @click="chiudiDettaglioMappa">x</button>
                    </b-col>
                </b-row>
            </template>

            <b-container fluid>
                <b-row>
                    <b-col sm="6" md="7" lg="8">
                        <div class="imgDiv" :id="'imgDivBig'" style="border:2px solid black; overflow: hidden;"   v-on:mousemove="mmove($event)" v-on:mouseup="mup($event)" >
                           
                               <img v-for="(lampInfo,index) in currentAmbiente.lamps" :key="'linfo2Big-'+currentAmbiente.id+'-'+lampInfo.id + imgLoaded"
                                ondragstart="return false"
                                :id="'dot'+lampInfo.id" :ref="'dot'+lampInfo.id" :src="'/img/dot_' + lampInfo.status+'_' + lampInfo.tipo + '.png'"  :class="[{dotSel: lampInfo.selected, dotImgBigEmergency: lampInfo.emergency=='on'},'dotImgBig']"
                                v-bind:style="{left: pos(-1,lampInfo).x, top:pos(-1,lampInfo).y}" v-on:mousedown="mdown(lampInfo, index ,$event)"  />

                                <img id="dragged" src="/img/dot_blu.png" class="dotImgBig dotSel" style="visibility: hidden" />
                           

                            <panZoom id="zoomContainer" ref="zoomContainer" @transform="zooming"  :options="{minZoom: 1.0, maxZoom: 5, bounds: true, boundsPadding: 1}" style="overflow: hidden">
                            <b-img id="imgBig" ref="imgBig" :src="imageUrl(currentAmbiente.id)" fluid ondragstart="return false" @load="bigImgLoaded" @drop="dropLamp(null,-1,$event)" @dragover.prevent />
                            </panZoom>
                            <b-button variant="warning" class="uploadButton"><i class="cui-cloud-upload icons" @click="uploadImg"></i></b-button>
                            <span class="infoTip" :content="$t('planimetry.info')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-2x fa-info-circle ml-3 mt-2" style="color:gold" ></i></span>
                            <div id="dropzoneContainer" v-if="showDropZone">
                                <b-button variant="danger" class="closeButton"><i class="fa fa-window-close" @click="closeDropZone"></i></b-button>
                                <vue-dropzone v-if="showDropZone"  ref="myVueDropzone" id="dropzone" :options="dropZoneOptions" v-on:vdropzone-file-added="fileAdded" v-on:vdropzone-sending="sendingImage" ></vue-dropzone>
                            </div>
                        </div>
                        
                    </b-col>
                    <b-col sm="6" md="5" lg="4" class="lampList">
                        <b-tabs v-model="tabIndex" class="PlanimetrieTabs">

                            <!-- Info dispositivo -->
                             <b-tab :title="$t('planimetry.tab_info')" lazy @click="resetFilterOnTabChange()">
                                 <div v-if="selectedLampDetails == null">
                                     <p>{{$t('planimetry.select_dot')}}</p>
                                 </div>
                                 <b-container fluid v-else >
                                     <b-row>
                                         <b-col class="subtitle"> 
                                             <p v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">{{$t("emergency_device")}}</p>
                                             <p v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">{{$t("lighting_device")}}</p>
                                             <p v-if="selectedLampDetails.device_function=='ALTRO'">{{$t("other_device")}}</p>
                                             <p v-if="selectedLampDetails.device_function=='CU'">{{$t("central_unit")}}</p>
                                             
                                             <!--- VISUALIZZAZIONE ANAGRAFICA LAMPADA -->
                                             <div v-if="selectedLampDetails.device_function!='CU'">
                                                <h5 v-if="!selectedLampDetails.product_desc.includes('Unknown')">{{selectedLampDetails.product_desc}}</h5>
                                                <h5 v-else>--</h5>
                                                <h5><b> ID: {{selectedLampDetails.id}}</b></h5>
                                                <h6 v-if="!selectedLampDetails.product_code.includes('NT')">cod: {{selectedLampDetails.product_code}}</h6>
                                                <h5 v-else>cod: --</h5>
                                              </div>
                                              
                                             <!--- VISUALIZZAZIONE ANAGRAFICA CENTRALE -->
                                             <div v-if="selectedLampDetails.device_function=='CU'">
                                                <h5>{{selectedLampDetails.cu_product_desc}}</h5>
                                                <h5><b> ID: {{selectedLampDetails.cu_id}}</b></h5>
                                                <div v-if="selectedLampDetails.cu_connected==true"> <i class="fa fa-2x fa-circle green"/> <span>{{this.$t('connessa').toUpperCase()}}</span></div>   
                                                <div v-if="selectedLampDetails.cu_connected==false"> <i class="fa fa-2x fa-circle gray" /> <span>{{this.$t('disconnessa').toUpperCase()}}</span></div>                                        
                                             </div>
                                             
                                             <!--- LAMPADE ORFANE -->
                                             <div v-if="hasOrphan(selectedLampDetails)">
                                               <div class="d-flex" v-if='selectedLampDetails.nodo_orfano==true'><i class="fa fa-2x fa-circle mr-2" style="color:violet"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_orphan_error")}}</span></div>
                                             </div>    
                                             
                                             <!--- LAMPADE IN EMERGENZA -->
                                             <div v-if='selectedLampDetails.emer_active=="EMERGENZA IN CORSO"'>
                                                    <b-iconstack font-scale="1.8" class="mr-2">
                                                      <b-icon stacked icon="plug" style="color: orange;" scale="1"></b-icon>
                                                      <b-icon stacked icon="lightning-fill"  scale="0.5" style="color: white;"></b-icon> 
                                                      <b-icon stacked icon="circle"  scale="1" style="color: orange ;"></b-icon>      
                                                   </b-iconstack>
                                                   <span class="pt-1 typo-label">{{$t("details_lamp.lamp_emergency_running")}}</span>
                                              </div>
                                           
                                              <!--- ERRORI COMMUNICAION LAMPADE -->
                                             <div v-if="hasErrorCom(selectedLampDetails)">
                                                <div class="d-flex" v-if='selectedLampDetails.error_com=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:#FFDE59"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_com")}}</span></div>
                                             </div>   
                                             
                                             <!--- ERRORI LAMPADE -->
                                             <div v-if="hasError(selectedLampDetails)">
                                                 <div class="d-flex" v-if='selectedLampDetails.error_batt_short=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_batt_short")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_batt_test=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_batt_test")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_batt_test_auto && selectedLampDetails.error_batt_test_auto=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_batt_test_auto")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_ric_incompleta && selectedLampDetails.error_ric_incompleta=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_ric_incompleta")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_tubo_UV && selectedLampDetails.error_tubo_UV=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_tubo_UV")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_hardware=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_hardware")}}</span></div>     
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led")}}</span></div>
                                                 
                                                 <!-- Emergenza sicuro -->
                                                 <div class="d-flex" v-if='selectedLampDetails.error_com_ak_lamp == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_com_ak_lamp")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_dali_com == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_dali_com")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_dali_hardware == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_dali_hardware")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_dali_lamp == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_dali_lamp")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_id_duplicate == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_duplicate")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led_full_short == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led_full_short")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led_open == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led_open")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_led_partial_short == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_led_partial_short")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_low_voltage == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_low_voltage")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_polarity_reverse == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_reverse_polarity")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_lamp_programming == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_programming")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_under_threshold == "ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_under_threshold")}}</span></div>
                                                 
                                                 <!-- errori su lampade di illuminazione -->
                                                 <div class="d-flex" v-if='selectedLampDetails.error_overpower=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_overpower")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_overvoltage=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_overvoltage")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_underpower=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_underpower")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.error_undervoltage=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_undervoltage")}}</span></div>

                                                 <!-- errori su lampade di illuminazione bluetooth -->
                                                 <div class="d-flex" v-if='selectedLampDetails.lampFail=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_fail")}}</span></div>
                                                 <div class="d-flex" v-if='selectedLampDetails.errorBallastCom=="ON"'><i class="fa fa-2x fa-exclamation-circle mr-2" style="color:red"></i><span class="pt-1 typo-label">{{$t("details_lamp.lamp_error_ballast_com")}}</span></div>
                                                  
                                             </div>
 
                                            <!--- LAMPADE OK -->
                                            <div v-if="!hasOrphan(selectedLampDetails) && !hasError(selectedLampDetails) && !hasErrorCom(selectedLampDetails)">
                                                <div class="d-flex"><i class="fa fa-2x fa-circle mr-2" style="color:green"></i><span class="pt-1 typo-label">{{stateDesc(selectedLampDetails)}}</span></div>
                                            </div>   
                                           

                                            <!--- ERRORI CENTRALE -->
                                            <div v-if="selectedLampDetails.device_function=='CU'">
                                               
                                            </div>                                       
                                             

                                         </b-col>
                                         <b-col v-if="selectedLampDetails.device_function=='CU'" cols="3" class="text-right" >
                                            <img v-if="selectedLampDetails.cu_product_image" :src="this.pathDeviceImages + selectedLampDetails.cu_product_image" style="width:100%; height: auto" />
                                            <img v-if="!selectedLampDetails.cu_product_image && selectedLampDetails.cu_type=='sicuro'" :src="this.pathDeviceImages + 'cu_sicuro.jpg'" style="width:100%; height: auto" />
                                        </b-col>
                                         <b-col v-else cols="3" class="text-right" >
                                             <img v-if="selectedLampDetails.product_image" :src="this.pathDeviceImages + selectedLampDetails.product_image" style="width:100%; height: auto" />
                                             <img v-if="!selectedLampDetails.product_image && selectedLampDetails.device_function=='ILLUMINAZIONE'" :src="this.pathDeviceImages + 'luminary.jpg'" style="height:100px;" />
                                             <img v-if="!selectedLampDetails.product_image && selectedLampDetails.device_function!='ILLUMINAZIONE'" :src="this.pathDeviceImages + 'emergency.jpg'" style="height:100px;" />
                                         </b-col>
                                     </b-row>
                                     <b-row class="mt-4">
                                         <b-col cols="12">
                                            <!-- button di aggiungi a zona di monitoraggio -->
                                            <b-button v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'" variant="primary" class="mr-3 mb-2" @click="showAddToMonitoringZone(selectedLampDetails)">
                                                {{$t("add_to_monitoring_zone.button_add_to_zone")}}
                                            </b-button>
                                         <table class="table tabInfoPlanimetrie">
                                             <tr>
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_desc")}}</td>
                                                 <td class="descCol">{{selectedLampDetails.desc}}</td>
                                             </tr>
                                             <tr v-if="this.$store.getters.isBluetooth">
                                                 <td class="labCol">{{this.$t("zone.label_zone_name")}}</td>
                                                 <td>{{selectedLampDetails.zoneName}}</td>
                                             </tr>
                                             <tr v-if="this.$store.getters.isCentralized  && selectedLampDetails.device_function!='CU'">   
                                                 <td class="labCol">{{this.$t("central_unit")}}</td>
                                                 <td>{{selectedLampDetails.cu_type.toUpperCase() + ' ' + selectedLampDetails.cu_id.split('#')[1]}}</td>
                                             </tr>
                                             <tr v-if="this.$store.getters.isCentralized && selectedLampDetails.device_function!='CU'">   
                                                 <td class="labCol">{{this.$t("report_pdf.centrale_desc")}}</td>
                                                 <td>{{selectedLampDetails.cu_details.cu_desc}}</td>
                                             </tr>
                                             <tr>
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_order_code")}}</td>
                                                 <td v-if="selectedLampDetails.device_function=='CU'">{{selectedLampDetails.cu_order_code}}</td>
                                                 <td v-else>{{selectedLampDetails.order_code}}</td>      
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_type")}}</td>
                                                 <td>{{selectedLampDetails.lamp_type}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_actual_power")}}</td>
                                                 <td>{{(parseFloat(selectedLampDetails.potenza_attuale).toFixed(1) + " W")}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_energy")}}</td>
                                                 <td>{{((parseFloat(selectedLampDetails.energia_consumata)/1000).toFixed(1) + " kWh")}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.device_function=='ILLUMINAZIONE'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_timeon")}}</td>
                                                 <td>{{(parseFloat(selectedLampDetails.TimeOn)).toFixed(0)  }}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_battery_state")}}</td>
                                                 <td>{{$t("param_lamp."+selectedLampDetails.battery_state)}}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                <td class="labCol">{{this.$t("details_lamp.battery_desc")}}</td>
                                                <td>{{selectedLampDetails.battery_desc}}</td>
                                            </tr>
                                            <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                <td class="labCol">{{this.$t("details_lamp.battery_code")}}</td>
                                                <td>{{selectedLampDetails.battery_code}}</td>
                                            </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_parity")}}</td>
                                                 <td>{{$t("param_lamp."+selectedLampDetails.parity)}}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_test_duration")}}</td>
                                                 <td>{{selectedLampDetails.test_duration}}</td>
                                             </tr>
                                             <tr v-if="!selectedLampDetails.device_function || selectedLampDetails.device_function=='EMERGENZA'">
                                                 <td class="labCol">{{this.$t("details_lamp.lamp_autonomy")}}</td>
                                                 <td>{{selectedLampDetails.autonomy}}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.cu_type=='bluetooth' && selectedLampDetails.gatewayId!=null">
                                                 <td class="labCol">Gateway: </td>
                                                 <td> {{ selectedLampDetails.gatewayId }}</td>
                                             </tr>
                                             <tr v-if="selectedLampDetails.cu_type=='bluetooth'">
                                                 <td class="labCol">{{this.$t("report_pdf.last_sync")}}</td>
                                                 <td> {{ moment(new Date(selectedLampDetails.last_sync)).utc().format('DD-MM-YYYY') + " " + moment(new Date(selectedLampDetails.last_sync)).format('HH:mm:ss') }}</td>
                                             </tr>
                                         </table>
                                         </b-col>
                                     </b-row>
                                 </b-container>
                             </b-tab>

                            <!-- elenco dispositivi posizionati su mappa  -->
                            <b-tab :title="$t('planimetry.tab_list')" lazy @click="resetFilterOnTabChange()">
                                <table class="table tabLampadeDragDrop" >
                                     <thead>
                                         <tr>
                                             <th style="width: 15%"> </th>
                                             <th style="width: 15%">ID</th>
                                             <th style="width: 40%">Desc.</th>
                                             <th style="width: 15%">System</th>
                                             <th style="width: 15%" v-if="this.$store.getters.isCentralized">Central</th>
                                         </tr>
                                     </thead>
                                     <tbody>
                                         <tr v-for="(lamp,index) in lampsOnMaps" :key="index" :id="'lrow-'+lamp.id" :class="{draggableRow: true, highlightedRow: (selectedLamp != null && selectedLamp.id == lamp.id)}" @click="highlightLamp(lamp,index,$event)" @dragstart="dragLamp(lamp,index,$event)">
                                             <td style="width: 15%">
                                                <i v-if="lamp.device_function=='CU'" class="fa fa-1x fa-tv" style="color:#0090CD;"></i>
                                                <i v-if="lamp.device_function!='CU'" class="fa fa-1x fa-lightbulb" style="color:#0090CD;"></i>
                                            </td>
                                             <td style="width: 15%"><strong>{{lamp.id}}</strong></td>
                                             <td style="width: 40%">{{lamp.desc}}</td>
                                             <td style="width: 15%">{{lamp.cu_type}}</td>
                                             <td style="width: 15%" v-if="lamp.cu_type!='bluetooth'">{{lamp.cu_id.split('#')[1]}}</td>
                                             <!--<td><span class="float-right"><b-button variant="white" class="p-0 m-0"><i class="fa fa-trash" style="color:black" @click="showModalRimuoviLampada(lamp)"></i></b-button></span></td>-->
                                         </tr>
                                     </tbody>
                                 </table>
                             </b-tab>

                             <!-- Posiziona su mappa -->
                            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
                                <b-tab v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab' ||  this.$store.state.user.usertype=='admin'" :title="$t('planimetry.tab_place')" lazy>
                                    <p>{{$t('planimetry.info_place')}}</p>
                                    <img src="/img/dot_drag.png" style="display: none" />
                                    <img src="/img/dot_drag_emergenza.png" style="display: none" />
                                    <img src="/img/dot_drag_illuminazione.png" style="display: none" />
                                    <img src="/img/dot_drag_altro.png" style="display: none" />
                                    
    
                                    <b-row style="display: flex; align-items: center">
                                        <b-col cols="6">
                                            <b-input-group>
                                            <b-form-input type="text" v-model="filtro_in_tab"></b-form-input>
                                            <!-- Attach Right button -->
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtro=filtro_in_tab"><i class="fa fa-search"></i></b-button>
                                                </b-input-group-append>       
                                                       <span class="ml-1" :content="$t('planimetry.search')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-1x fa-info-circle" style="color:#009de0"></i></span> 
                                            </b-input-group>
                                        </b-col>    
                                        <b-col cols="6">
                                            <b-form-select v-model="tipiLampade"> 
                                                <b-form-select-option value="">{{$t('navbar_dispositivi.all')}}</b-form-select-option>
                                                <b-form-select-option value="emerg">{{$t('navbar_dispositivi.emergency')}}</b-form-select-option>
                                                <b-form-select-option value="illum">{{$t('navbar_dispositivi.lighting')}}</b-form-select-option>
                                                <b-form-select-option value="sens">{{$t('navbar_dispositivi.sensor')}}</b-form-select-option>
                                                <b-form-select-option v-for="cu in this.plantDetails.controlunits" :value="'cu'+cu.cuid" :key="cu.cuid">{{cu.cutype=='blegateway'? 'Gateway' : $t('central_unit')}} {{cu.cuid}}</b-form-select-option>
                                            </b-form-select>
                                        </b-col> 
                                    </b-row>
                                    <b-row style="display: flex; align-items: center">
                                        <b-col cols="12" class="float-right mt-4 mb-1">
                                            <b-form-checkbox v-model="filtroLampadeLibere" size="sm" style="display:inline" value="true" @change="filtraLampadeLibere">
                                                <span class="typo-label mr-1" style="font-weight:normal">{{this.$t("planimetry.not_assigned")}}</span>
                                            </b-form-checkbox>               
                                        </b-col>    
                                    </b-row> 
                                
                                    <!--<b-container fluid>-->
                                    <table class="table tabLampadeDragDrop" >
                                        <thead>
                                            <tr>
                                                <th style="width: 10%"> </th>
                                                <th style="width: 15%">ID</th>
                                                <th style="width: 35%">Desc.</th>
                                                <th style="width: 15%">System</th>
                                                <th style="width: 15%" v-if="this.$store.getters.isCentralized">Central</th>
                                                <th style="width: 10%"></th>
                                            </tr>
                                        </thead>
                                        <tbody> 
                                            <tr v-for="(lamp,index) in allLamps" :key="'row-'+index" :id="'lamprow-'+lamp.id" :draggable="!lamp.alreadyAdded && imgLoaded" :class="{draggableRow: true, highlightedAdded:(selectedLamp != null && selectedLamp.id != lamp.id && lamp.alreadyAdded) ,highlightedRow: (selectedLamp != null && selectedLamp.id == lamp.id)}" @click="highlightLamp(lamp,index,$event)" @dragstart="dragLamp(lamp,index,$event)">
                                                <td style="width: 10%">
                                                    <div v-if="lamp.device_function=='CU'"><i class="fa fa-1x fa-tv" style="color:#0090CD;"></i></div>
                                                    <i v-if="lamp.device_function!='CU'" class="fa fa-1x fa-lightbulb" style="color:#0090CD;"></i>
                                                </td>
                                                <td style="width: 15%"><strong>{{lamp.id}}</strong></td>
                                                <td style="width: 35%">{{lamp.desc}}</td>
                                                <td style="width: 15%">{{lamp.cu_type}}</td>
                                                <td style="width: 15%" v-if="lamp.cu_type!='bluetooth'">{{lamp.cu_id.split('#')[1]}}</td>
                                                <td style="width: 10%"><span class="float-right pr-3" ><b-button v-if="lamp.alreadyAdded==true" variant="white" class="p-0 m-0"><i class="fa fa-trash" style="color:black" @click="showModalRimuoviLampada(lamp)"></i></b-button></span></td>
                                            </tr>
                                        </tbody>

                                    </table>
                                    <!--</b-container>-->
                                </b-tab>
                                </show-at>
 
                          
                         </b-tabs>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

        <!-- Modal Rimuovi lampada da mappa-->
        <b-modal 
            id="modal-remove-lamp" 
            ref="modalRemoveLamp"
            centered 
            hide-header
            @ok="rimuoviLampada(lampToRemove)"
            >
            <h5 v-if="this.lampToRemove!=null">{{$t('planimetry.remove_lamp',{lamp: this.lampToRemove.id})}}</h5>
        </b-modal>

        <!-- Modal Disclaimer su upload photo-->
        <b-modal
            ref="modalDisclaimerPhoto"
            id="modal-disclaimer-photo"
            :title="$t('settings.normaTitle')"
            :ok-title="$t('settings.normaAccept')"
            @ok="accettazioneDisclaimerPhoto"
        >
            <label for="typo-label">
            <disclaimer-photo-ITA v-if="$t('language')=='IT'"></disclaimer-photo-ITA>
            <disclaimer-photo-GER v-if="$t('language')=='DE'"></disclaimer-photo-GER>
            <disclaimer-photo-ENG v-else></disclaimer-photo-ENG>
            </label>
        </b-modal>

    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain'
import NavBarDispositivi from '@/components/NavBarDispositivi'
import DisclaimerPhotoITA from '@/locales/DisclaimerPhotoITA';
import DisclaimerPhotoENG from '@/locales/DisclaimerPhotoENG';
import DisclaimerPhotoGER from '@/locales/DisclaimerPhotoGER';
import BannerProExpired from '@/components/BannerProExpired';
import BannerPro from '@/components/BannerPro';
import {showAt, hideAt} from 'vue-breakpoints';
//import DragItDude from 'vue-drag-it-dude';

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import panZoom from 'vue-panzoom'
Vue.use(panZoom);

import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;
import AddToMonitoringZone from '@/components/MonitoringZone/AddToMonitoringZone';

import { mapState } from 'vuex';
import ErrorBanner from '@/components/ErrorBanner';

export default {
    name: 'AmbientiPlanimetrie',
    components: {
        NavBarMain,
        NavBarDispositivi,
        Event,
        BannerPro,
        BannerProExpired,
        DisclaimerPhotoITA,
        DisclaimerPhotoENG,
        DisclaimerPhotoGER,
        vueDropzone: vue2Dropzone,
        jsPDF,
        JsPDFAutotable,
        hideAt, 
        showAt,
        AddToMonitoringZone,
        ErrorBanner
    },
    props: ['plantId'],
    data() {
        return {
            section: "ambienti",
            tipiLampade: "",
            highlightedLamp: "",
            filtro: "",
            filtro_in_tab:"",
            tabIndex: 0,
            lampToRemove:null,
            draggedLamp: null,
            showDropZone: false,
            imgLoaded: false,
            imgUploaded: false,
            pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,  
            pathMapImages: process.env.VUE_APP_PATH_MAP,    
            picLoaded: {},
            updatingName: false,
            dropZoneOptions: {
                url: process.env.VUE_APP_API_REST_URL,
                maxFilesize: 1.5,
                acceptFiles: "image/*",
                autoProcessQueue: false,
                autoQueue: false,
                maxFiles: 1
            },
            dragging: false,
            drgX: '0px',
            drgY: '0px',
            dragStartEv: null,
            lampListFields: [
                {key: 'id', label: 'ID' },
                {key: 'status', label: 'Stato'}
            ],
            allLampsFields: [
                {key: 'id', label: 'ID' },
                {key: 'cu_id', label: 'Centrale'},
                {key: 'desc', label: 'Nome'}
            ],
            currentAmbiente: {},
            selectedLamp: null,
            
            theme: 'bootstrap4',
            template: 'default',  
            filtroLampadeLibere: false,
            lampToAdd:null,
            modalAddToZone:false,
            resetAddToZone:false,
            allLampsPlaced:[],
            alerts:[]
        }     
    
    },
    filters: {
        
        tipoCentrale: function(value) {
            if (value == 'cablecom') return "Centrale CableCom"
            return "Centrale " + value
        },
        
    },
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),
        
        rndId() {
            return Math.random();
        },
        /*tabIndex() {
            if (this.currentAmbiente != null && this.currentAmbiente.isNew) return 1;
            return 0;
        },*/
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return null;
            if (plant.id != this.plantId) return null;
            return plant;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        zonesDetails() {
            return this.$store.state.plantZones;
        },
        lampListItems() {
            if (this.currentAmbiente == null || this.currentAmbiente.lamps == null) return [];
            console.log("lampListItems: lamps: ",this.currentAmbiente.lamps);
            return this.currentAmbiente.lamps;
        },
        selectedLampDetails() {
            if (this.selectedLamp == null) return null;
            const selLamp = this.selectedLamp;
            const lampDet = this.allLamps.filter(function (l) {
                return l.id == selLamp.id;
            });
            console.log("selected lamp details:", lampDet);
            if (lampDet != null && lampDet.length > 0) {
                this.unitsDetails.forEach(function (cu) {
                    if (lampDet[0].cu_id == (cu.cu_type+'#'+cu.cu_id))
                        lampDet[0].cu_details = cu; 
                });
                if(lampDet[0].cu_type=='bluetooth')
                {
                    if (lampDet[0].zone_id==null)
                        lampDet[0].zone_id=lampDet[0].cu_id;
                    this.zonesDetails.forEach(function (zone) {
                        if (lampDet[0].zone_id.split('#')[2] == zone.zoneId)
                        {
                            lampDet[0].zoneName = zone.zoneName; 
                            lampDet[0].zoneNumber = zone.zoneNumber; 
                        }
                    });
                }
                return lampDet[0];
            }
            return null;
        },
        allLamps() {
            var lamps = [];
           
            var flt = this.filtro;

            var flt2 = this.filtroLampadeLibere;
            var flt3 = this.tipiLampade;
            
            var cent_to_add=null;

            console.log("ricomputo allLamps, flt3=" + flt3);

            //aggiungi lampade bluetooth
            if (this.zonesDetails != null && this.currentAmbiente != null && this.$store.getters.isBluetooth && !this.$store.getters.isCentralized)
            {
                const llitems = this.lampListItems;
                this.zonesDetails.forEach(function (z) {

                    console.log("zone", z);

                    //bluetooth emergenza
                    if (z.bleLamps != null && z.bleLamps.length > 0 ) lamps = lamps.concat(
                        z.bleLamps.reduce(
                            function(filtered, bleLamp) {

                                var l = bleLamp.lamp;
                                l.id = l.lamp_id;  
                                l.gatewayId = z.gatewayId;
                                if (l.device_function == "ILLUMINAZIONE")
                                {
                                    l.potenza_attuale = l.istantaneousPower;
                                    l.energia_consumata = l.energy;
                                    l.TimeOn = l.functionHours;
                                }   

                                //aggiungi lampade
                                if(flt3.includes("cu") && z["gatewayId"]!=flt3.replace("cu",""))
                                    return [];
                                if(flt3.includes("emerg") && l.autonomy.includes('?'))
                                    return filtered;
                                if(flt3.includes("illum") && !l.autonomy.includes('?'))
                                    return filtered;
                                if(flt3.includes("sens"))
                                    return [];
                                if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                        console.log("filtered lamp",l);
                                    } else {
                                        return filtered;
                                    }
                                }
                            
                                l["cu_id"].includes(z.zoneId); 
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;
                                
                                //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }
                                
                                //TODO: inserire posizionamento su mappa dei gateway    
                                                    
                                return filtered;
                            }, []
                        )
                    );

                });
            }

            //aggiungi lampade centralizzate
            else if (this.unitsDetails != null && this.currentAmbiente != null) {
                
                const llitems = this.lampListItems;
                this.unitsDetails.forEach(function(u) {
                    
                    //emergency lamps in cablecom, logica, logicafm
                    if ((flt3 == "" || flt3 == "emerg" || flt3.includes("cu")) && u.lamps != null && u.lamps.length > 0 && u.cu_type!="sicuro") lamps = lamps.concat(
                        u.lamps.reduce(
                            function(filtered, l) {

                                //aggiungi le centrali da posizionare
                                if(cent_to_add!=u)
                                {
                                  cent_to_add=u;
                                  cent_to_add.id=cent_to_add.cu_id;
                                  cent_to_add.desc=cent_to_add.cu_desc;
                                  cent_to_add.device_function="CU";
                                  const acent = llitems.filter(function(al) {
                                      return (al.id == u.id);
                                        })
                                  if (acent != null && acent.length > 0) 
                                      cent_to_add.alreadyAdded = true;
                                  else
                                      cent_to_add.alreadyAdded = false;
                                  filtered.push(cent_to_add);
                                }
                                l["device_function"]="EMERGENZA";
                                if(l["cu_type"]=="bluetooth" && l["cu_id"].includes("ble#"))
                                {
                                    l["zone_id"]=l["cu_id"];
                                    l["cu_id"]="blegateway#"+u.id;
                                }

      
                                //aggiungi lampade
                                if(flt3.includes("cu") && l["cu_id"].split('#')[1]!=flt3.replace("cu",""))
                                    return [];
                                else
                                    //console.log("id lamp filtered for cent", l.id);
                                if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                        console.log("filtered lamp",l);
                                    } else {
                                        return filtered;
                                    }
                                }
                            
                                //l["cu_id"] = u.cu_id; 
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;

                                //se è abilitato il filtro sulle lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }

                                                    
                                return filtered;
                            }, []
                        )
                    );

                    //emergency lamps in sicuro
                    if ((flt3 == "" || flt3 == "emerg" || flt3.includes("cu")) && u.cu_type=="sicuro" && (u.ak.length+u.ak_ext.length)>0) 
                    {

                        u.ak.forEach((ak_item)=>{
                                ak_item.lines.forEach((line)=>{
                                   lamps = lamps.concat (
                                            line.lamps.reduce(
                                                function(filtered, l) {

                                                    //aggiungi le centrali da posizionare
                                                    if(cent_to_add!=u)
                                                    {
                                                    cent_to_add=u;
                                                    cent_to_add.id=cent_to_add.cu_id;
                                                    cent_to_add.desc=cent_to_add.cu_desc;
                                                    cent_to_add.device_function="CU";
                                                    const acent = llitems.filter(function(al) {
                                                        return (al.id == u.id);
                                                            })
                                                    if (acent != null && acent.length > 0) 
                                                        cent_to_add.alreadyAdded = true;
                                                    else
                                                        cent_to_add.alreadyAdded = false;
                                                    filtered.push(cent_to_add);
                                                    }

                                                    l.id=l.lamp_id;
                                                    if(flt3.includes("cu") && l["cu_id"]!=flt3.replace("cu",""))
                                                        return [];
                                                    if (flt != null && flt != "") {
                                                        if (l.id.includes(flt.toUpperCase())) {
                                                            console.log("filtered",flt);
                                                            console.log("filtered lamp",l);
                                                        } else {
                                                            return filtered;
                                                        }
                                                    }
                                                
                                                    // l["cu_id"] = u.cu_id; 
                                                    var alreadyAdded = false;
                                                    const alamp = llitems.filter(function(al) {
                                                        return (al.id == l.id);
                                                    })
                                                    if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                                    l["alreadyAdded"] = alreadyAdded;
                                                    
                                                    //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                                    if (flt2=='true')
                                                    {
                                                        if(l.alreadyAdded==false)
                                                            filtered.push(l);
                                                    }
                                                    else
                                                    {
                                                        filtered.push(l);
                                                    }
                                                    
                                                    //aggiungi le centrali da posizionare
                                                    if(cent_to_add!=u)
                                                    {
                                                    cent_to_add=u;
                                                    cent_to_add.id=cent_to_add.cu_id;
                                                    cent_to_add.desc=cent_to_add.cu_desc;
                                                    cent_to_add.device_function="CU";
                                                    const acent = llitems.filter(function(al) {
                                                        return (al.id == u.id);
                                                            })
                                                    if (acent != null && acent.length > 0) 
                                                        cent_to_add.alreadyAdded = true;
                                                    else
                                                        cent_to_add.alreadyAdded = false;
                                                    filtered.push(cent_to_add);
                                                    }
                                                                        
                                                    return filtered;
                                                }, []
                                             )
                                    )
                                });
                            });

                            u.ak_ext.forEach((ak_item)=>{
                                ak_item.lines.forEach((line)=>{
                                   lamps = lamps.concat (
                                            line.lamps.reduce(
                                                function(filtered, l) {
                                                    l.id=l.lamp_id;
                                                    if(flt3.includes("cu") && l["cu_id"]!=flt3.replace("cu",""))
                                                        return [];
                                                    if (flt != null && flt != "") {
                                                        if (l.id.includes(flt.toUpperCase())) {
                                                            console.log("filtered",flt);
                                                            console.log("filtered lamp",l);
                                                        } else {
                                                            return filtered;
                                                        }
                                                    }
                                                
                                                    // l["cu_id"] = u.cu_id; 
                                                    var alreadyAdded = false;
                                                    const alamp = llitems.filter(function(al) {
                                                        return (al.id == l.id);
                                                    })
                                                    if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                                    l["alreadyAdded"] = alreadyAdded;
                                                    
                                                    //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                                    if (flt2=='true')
                                                    {
                                                        if(l.alreadyAdded==false)
                                                            filtered.push(l);
                                                    }
                                                    else
                                                    {
                                                        filtered.push(l);
                                                    }
                                                
                                                                        
                                                    return filtered;
                                                }, []
                                             )
                                    )
                                });
                            });
                    }

                    if ((flt3 == "" || flt3 == "illum" || flt3.includes("cu")) && u.lamps_illum != null && u.lamps_illum.length > 0) lamps = lamps.concat(
                        u.lamps_illum.reduce(
                            function(filtered, l) {

                                //aggiungi le centrali da posizionare
                                if(cent_to_add!=u)
                                {
                                  cent_to_add=u;
                                  cent_to_add.id=cent_to_add.cu_id;
                                  cent_to_add.desc=cent_to_add.cu_desc;
                                  cent_to_add.device_function="CU";
                                  const acent = llitems.filter(function(al) {
                                      return (al.id == u.id);
                                        })
                                  if (acent != null && acent.length > 0) 
                                      cent_to_add.alreadyAdded = true;
                                  else
                                      cent_to_add.alreadyAdded = false;
                                  filtered.push(cent_to_add);
                                }

                                l["device_function"]="ILLUMINAZIONE";
                                if(l["cu_type"]=="bluetooth" && l["cu_id"].includes("ble#"))
                                {
                                    l["zone_id"]=l["cu_id"];
                                    l["cu_id"]="blegateway#"+u.id;
                                }

      
                                //aggiungi lampade
                                if(flt3.includes("cu") && l["cu_id"].split('#')[1]!=flt3.replace("cu",""))
                                    return [];
                                    if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                    } else {
                                        return filtered;
                                    }
                                }

                                // l["cu_id"] = u.cu_id; 
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;
                                
                                //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }

                                return filtered;
                            }, []
                        )
                    );

                    if ((flt3 == "" || flt3 == "sens"|| flt3.includes("cu")) && u.sensors != null && u.sensors.length > 0) lamps = lamps.concat(
                        u.sensors.reduce(
                            function(filtered, l) {

                                //aggiungi le centrali da posizionare
                                if(cent_to_add!=u)
                                {
                                  cent_to_add=u;
                                  cent_to_add.id=cent_to_add.cu_id;
                                  cent_to_add.desc=cent_to_add.cu_desc;
                                  cent_to_add.device_function="CU";
                                  const acent = llitems.filter(function(al) {
                                      return (al.id == u.id);
                                        })
                                  if (acent != null && acent.length > 0) 
                                      cent_to_add.alreadyAdded = true;
                                  else
                                      cent_to_add.alreadyAdded = false;
                                  filtered.push(cent_to_add);
                                }

                                if(flt3.includes("cu") && l["cu_id"]!=flt3.replace("cu",""))
                                    return [];
                                    if (flt != null && flt != "") {
                                    if (l.id.includes(flt.toUpperCase())) {
                                        console.log("filtered",flt);
                                    } else {
                                        return filtered;
                                    }
                                }

                                // l["cu_id"] = u.cu_id; 
                                var alreadyAdded = false;
                                const alamp = llitems.filter(function(al) {
                                    return (al.id == l.id);
                                })
                                if (alamp != null && alamp.length > 0) alreadyAdded = true;
                                l["alreadyAdded"] = alreadyAdded;
                                
                                //se è abilitato il filtro sulle sole lampade posizionate in questa mappa
                                if (flt2=='true')
                                {
                                    if(l.alreadyAdded==false)
                                        filtered.push(l);
                                }
                                else
                                {
                                    filtered.push(l);
                                }

                                return filtered;
                            }, []
                        )
                    );


                });
            }
            console.log("all lamps:",lamps);
            return lamps;
        },
        lampsOnMaps(){
            var lamps_on_maps=[];
            lamps_on_maps= this.allLamps.filter (function(lamp) 
            {
                if(lamp.cu_id.includes("sicuro"))
                    lamp.id=lamp.lamp_id;
                return (lamp.alreadyAdded == true);
            });
            console.log("lamps on maps",lamps_on_maps);
            return lamps_on_maps;
        },
        lampsNotPlacedInOtherMaps(){
            var lamps_not_placed_in_other_maps=[];
            let self = this;
            lamps_not_placed_in_other_maps=this.allLamps.filter (function(lamp) 
            {
                return !self.allLampsPlaced.find(el => (el.id === lamp.id ))
            });
            console.log("lamps not placed in other maps",lamps_not_placed_in_other_maps);
            return lamps_not_placed_in_other_maps;
        },
        ambienti() {
            if (this.plantDetails == null || this.plantDetails[this.section] == null) return [];
            let self = this;

            self.allLampsPlaced=[];
            return this.plantDetails[this.section].map(function(a){
                //console.log("mappo " + self.section, a);
                let lamps1 = a.lamps.filter(function(l) {
                    //console.log("mappate ",l.id, l.tipo);
                    if(l.tipo=="cu")
                        return self.findCu(l.id) !=null;
                    else
                        return self.findLamp(l.id) != null;
                });

                let lamps = lamps1.map(function(l){
                    //trovo la lampada
                    var status = "ok";
                    var emergency ="off";
                    let lampInfo = l.tipo=="cu"?  self.findCu(l.id) : self.findLamp(l.id);
                 
                    if (lampInfo != null) {
                        if (self.hasOrphan(lampInfo)) status = 'orphan';
                        else if (self.hasError(lampInfo)) status = 'err';
                        else if (self.hasErrorCom(lampInfo)) status = 'errcom';
                        
                        if(self.isInEmergency(lampInfo)) emergency ='on' 
                    }

                    return {id: l.id, status: status, px: l.px, py: l.py, selected: false, tipo: self.tipoLamp(lampInfo), emergency: emergency}
                })
                //a.lamps = lamps;
                //console.log("lamps in ambient_planimetry ", a.name , " : ", a.lamps);
                //self.allLampsPlaced=self.allLampsPlaced.concat(a.lamps);
                //console.log("all lamps placed: ",self.allLampsPlaced);
                //return a;
                return {...a, lamps: lamps};
            });
        },

        
    },
    async mounted() {
        console.log("AmbientiPlanimetrie mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails)
        console.log("router-->", this.$router);
        this.section = this.$router.currentRoute.name.toLowerCase();
        console.log("sezione ambienti/planimetrie=" + this.section);
        window.addEventListener('resize', this.handleResize);
        if (this.$store.state.user != null && this.error == null && this.$store.getters.isBluetooth && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected)
        {
            if (this.$store.state.plantZones == null)
            {
                this.$store.dispatch('loadPlantZones', this.plantId)
            }
            else
            {
                console.log("aggiornato plant zones", this.zonesDetails);
            }
        }
        else if (this.$store.state.user != null && this.error == null && this.plantDetails == null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected)
        {
            if (this.$store.getters.isBluetooth)
            {
                if (this.$store.state.plantZones == null) {
                    this.$store.dispatch('loadPlantZones', this.plantId)
                }
            }
            else  
                this.$store.dispatch('loadPlantDetails', this.plantId)
        } else {
            let self = this;
            this.$nextTick(() => {
                self.$forceUpdate();
            });
        }
        // Call the method to load fonts when the component is mounted
        await this.loadFonts();
    },
    updated() {
        //console.log("dispositiviImpianto updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        if(this.tabIndex!=2) 
            {
                this.filtroLampadeLibere=false;
                this.filtro="";

        }
            
        /*if (this.plantDetails == null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        } */
    },
    
    watch: {
        loading(val) {
            console.log("loading changed:" + val+", error=" + this.error)
            if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
             } else if (val == false && this.plantDetails != null && this.$store.getters.isBluetooth && this.zonesDetails == null && this.error == null) {
                console.log("carico zone details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
                this.$store.dispatch('loadPlantZones', this.plantId)    
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null) {
                console.log("devo elaborare risposta comando ", this.$store.state.commandResponse);
                /*var alert = {
                    timeLeft: 5,
                    msg: "Eseguito comando " + this.$store.state.commandResponse.command + " su centrale " + this.$store.state.commandResponse.cu,
                    countDownChanged: function(cd) {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.alerts.push(alert);*/
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null) {
                console.log("dati pronti lampade centralizate");
            }  else if (val == false && this.plantDetails != null && this.zonesDetails != null) {
                console.log("dati pronti zone bluetooth");
            }
            this.$forceUpdate();
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);
            
        },
        commandResponse(val) {
            console.log("updated commandResponse:",val);
            if (val.command == 'disclaimerPhotoAccepted'&& val.pending == false) {
                this.aggiungiPianta();       
            } 
        },

        // 'immediate: true' fa sì che il handler venga eseguito immediatamente quando il componente viene creato per la prima volta. 
        // Questo è fondamentale perché volgiamo che l'array this.allLampsPlaced sia popolato con i dati iniziali non appena il componente è pronto, 
        // non solo dopo che i dati cambiano.
        ambienti: {
            immediate: true, 
            handler(newAmbienti) {
                let consolidatedLamps = [];
                
                newAmbienti.forEach(ambiente => {
                    consolidatedLamps = consolidatedLamps.concat(ambiente.lamps);
                });

                // 🛑 Side Effect consentito: aggiornamento dello stato locale del componente
                this.allLampsPlaced = consolidatedLamps; 
            }
        }

    },
    methods: {
        //----------------------------------------------------------------------------
        // Resetta lo zoom riposizionando correttamente le icone
        //----------------------------------------------------------------------------
        resetZoomToZero() {
            if (this.$refs.zoomContainer && this.$refs.zoomContainer.$panZoomInstance) {
                console.log("Resetting zoom to initial position and scale.");
                // Reset to initial position and scale using absolute methods
                const instance = this.$refs.zoomContainer.$panZoomInstance;
                instance.moveTo(0, 0);
                instance.zoomAbs(0, 0, 1); // x, y, absolute scale
                const transform = instance.getTransform();
                while (transform.x !== 0 || transform.y !== 0 || transform.scale !== 1) {
                    console.warn("Transform not reset yet, retrying...");
                    instance.moveTo(0, 0);
                    instance.zoomAbs(0, 0, 1); // x, y, absolute scale
                }
            }
        },

        //Loads all required fonts and stores them in component data.
        async loadFonts() {
            try {
                // Assumes fonts are in your 'public' folder
                this.robotoRegular = await this.loadFontAsBase64('/fonts/Roboto-Regular.ttf');
                this.robotoBold = await this.loadFontAsBase64('/fonts/Roboto-Bold.ttf');
                //console.log('Fonts loaded successfully.');
            } catch (error) {
                console.error('Failed to load fonts:', error);
            }
        },        
        // Helper function to load a font from a URL and convert it to Base64
        async loadFontAsBase64(url) {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Get the Base64 string, but strip the "data:..." prefix
                    const base64data = reader.result.split(',')[1];
                    resolve(base64data);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },

        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) 
            {
               return user[0].role;
            }
            return "?";
        },
        resetFilterOnTabChange()
        {
            this.tipiLampade="";
        },
        showAddToMonitoringZone(lampMonitor)
        {
           this.lampToAdd = lampMonitor;
           this.modalAddToZone = true;
        },
        //funzione che genera un file pdf con la mappa e le lampade posizionate
        async generaPdfMappa() {
            // Define the target icon size as a percentage of the map height
            const ICON_SIZE_PERCENT = 4.0;

            let self = this;
            console.log("genero pdf mappa");

            var mappa = document.createElement("img");
            var lampOK = document.createElement("img");
            lampOK.src = "/img/dot_ok.png";
            var lampERR = document.createElement("img");
            lampERR.src = "/img/dot_err.png";
            var lampERRCOM = document.createElement("img");
            lampERRCOM.src = "/img/dot_errcom_emergenza.png";
            var illumOK = document.createElement("img");
            illumOK.src = "/img/dot_ok_illuminazione.png";
            var illumERR = document.createElement("img");
            illumERR.src = "/img/dot_err_illuminazione.png";
            var illumERRCOM = document.createElement("img");
            illumERRCOM.src = "/img/dot_errcom_illuminazione.png";
            var centOK = document.createElement("img");
            centOK.src = "/img/dot_ok_cu.png";
            var centERR = document.createElement("img");
            centERR.src = "/img/dot_err_cu.png";
            var centOFFLINE = document.createElement("img");
            centOFFLINE.src = "/img/dot_offline_cu.png";
            var lampORPHAN = document.createElement("img");
            lampORPHAN.src = "/img/dot_orphan_emergenza.png";
            var illumORPHAN = document.createElement("img");
            illumORPHAN.src = "/img/dot_orphan_illuminazione.png";

            //scarico la mappa dal server passando dall'API Gateway e dalla Lambda main
            let planUrl = `${process.env.VUE_APP_API_REST_URL}?action=getResource&type=${this.section}&id=${this.plantId}-${this.currentAmbiente.id}`;
            console.log("planUrl=" + planUrl);
            mappa.src = planUrl;
            mappa.crossOrigin="anonymous";
            await mappa.decode();

            var imgAspect = mappa.width / mappa.height;
            var pageAspect = 26.0 / 19.0

            console.log("immagine:" + mappa.width + "x" + mappa.height + ", aspect:" + imgAspect+", page aspect:" + pageAspect);

            var pw = 0;
            var ph = 0;
            if (imgAspect > pageAspect) {
                pw = 26.0;
                ph = 26.0 / imgAspect;
            } else {
                ph = 19.0;
                pw = 19.0 * imgAspect;
            }         

            var pAspect = pw / ph;

            console.log("dimensioni stampa:" + pw + "x" + ph + ", aspect:" + pAspect);

            const iconSize = Math.round((ICON_SIZE_PERCENT / 100) * mappa.height);
            var canvas = document.createElement("canvas");
            canvas.width = mappa.width;
            canvas.height = mappa.height;

            // Copy the image contents to the canvas
            var ctx = canvas.getContext("2d");
            ctx.drawImage(mappa, 0, 0);

            //Disegno le lampade sulla mappa
            var nDisp = self.currentAmbiente.lamps.length;
 
            // Update the text size and positioning as well (using iconSize or a factor of it):
            ctx.font = `bold ${iconSize * 0.5}px Roboto, Arial, Helvetica`; // Make font relative to icon size
            // Position text relative to the new icon size (e.g., 10px offset from icon center)
            const textOffsetX = iconSize * 0.6;
            const textOffsetY = iconSize * 0.7;

            for (var l=0; l<nDisp; l++) {
                var lamp = self.currentAmbiente.lamps[l];

                // --- 1. SET WHITE SHADOW FOR ICON ---
                ctx.shadowColor = 'rgba(256, 256, 256, 0.6)'; 
                ctx.shadowBlur = 4;
                ctx.shadowOffsetX = 2;
                ctx.shadowOffsetY = 2;
                var deviceIcon = null;
                if (lamp.tipo == 'cu') {
                    deviceIcon = (lamp.status == 'ok') ? centOK : (lamp.status == 'offline') ? centOFFLINE : centERR;
                    ctx.drawImage(deviceIcon, lamp.px * mappa.width / 100.0 - (iconSize / 2) , lamp.py * mappa.height / 100.0  - (iconSize / 2), iconSize, iconSize);
                    //id effetto ombra (bianco e nero sovrapposti scostati di 1px)
                    ctx.fillStyle = "#FFFFFF"; //bianco
                    ctx.fillText(lamp.id, lamp.px * mappa.width / 100.0 - textOffsetX - 1, lamp.py * mappa.height / 100.0 - textOffsetY - 1);
                    ctx.fillStyle = "#000000"; //nero
                    ctx.fillText(lamp.id, lamp.px * mappa.width / 100.0 - textOffsetX, lamp.py * mappa.height / 100.0 - textOffsetY);
                } else if (lamp.tipo == 'emergenza') {
                    deviceIcon = (lamp.status == 'ok') ? lampOK : (lamp.status == 'orphan') ? lampORPHAN : (lamp.status == 'errcom') ? lampERRCOM : lampERR;
                    ctx.drawImage(deviceIcon, lamp.px * mappa.width / 100.0 - (iconSize / 2) , lamp.py * mappa.height / 100.0  - (iconSize / 2), iconSize, iconSize);
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillText(lamp.id, lamp.px * mappa.width / 100.0 - textOffsetX - 1, lamp.py * mappa.height / 100.0 - textOffsetY - 1);
                    ctx.fillStyle = "#000000";
                    ctx.fillText(lamp.id, lamp.px * mappa.width / 100.0 - textOffsetX, lamp.py * mappa.height / 100.0 - textOffsetY);
                } else if (lamp.tipo == 'illuminazione') {
                    deviceIcon = (lamp.status == 'ok') ? illumOK : (lamp.status == 'orphan') ? illumORPHAN : (lamp.status == 'errcom') ? illumERRCOM : illumERR;
                    ctx.drawImage(deviceIcon, lamp.px * mappa.width / 100.0 - (iconSize / 2) , lamp.py * mappa.height / 100.0  - (iconSize / 2), iconSize, iconSize);
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillText(lamp.id, lamp.px * mappa.width / 100.0 - textOffsetX - 1, lamp.py * mappa.height / 100.0 - textOffsetY - 1);
                    ctx.fillStyle = "#000000";
                    ctx.fillText(lamp.id, lamp.px * mappa.width / 100.0 - textOffsetX, lamp.py * mappa.height / 100.0 - textOffsetY);
                }
                // --- 3. CLEAR SHADOW before drawing text or anything else ---
                ctx.shadowColor = 'transparent'; // Use 'transparent' or 'rgba(0, 0, 0, 0)'
                ctx.shadowBlur = 0;
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
            }

            var dataURL = canvas.toDataURL("image/png").replace(/^data:image\/(png|jpg);base64,/, "");

            console.log("currentPlant",self.$store.state.currentPlant,self.currentAmbiente );
            var doc = new jsPDF('p', 'pt');

            doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
            doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
            // Use 'Identity-H' encoding for the font registration to enable Unicode support
            doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
            doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

            doc.setFont('Roboto', 'bold');

            doc.setFontType("bold");
            doc.setFontSize(14);
            doc.text("Impianto: " + self.$store.state.currentPlant.plantname,29,28);
            doc.text("Ambiente: " + self.currentAmbiente.name,29,48);

            doc.addImage(dataURL,"PNG", 29,70 - ph * 28.3 ,pw * 28.3,ph * 28.3,"map","FAST",-90);
            doc.addPage();

            var columns = [
                {title: self.$t('details_lamp.lamp_id'), dataKey: "id"},
                {title: self.$t('details_lamp.lamp_desc'), dataKey: "desc"}, 
                {title: self.$t('details_lamp.lamp_code'), dataKey: "code"},
                {title: self.$t('details_lamp.lamp_type'), dataKey: "type"},
                {title: self.$t('details_lamp.central_type'), dataKey: "cent_type"},
                {title: self.$t('details_lamp.central_id'), dataKey: "cent_id"}, 
            ];

            var rows = [];
            for (l=0; l<nDisp; l++) {
                if (self.currentAmbiente.lamps[l].tipo=="cu")
                    continue;
                lamp = self.findLamp(self.currentAmbiente.lamps[l].id);
                console.log("lamp",lamp);
                rows.push({
                    id: lamp.id ,
                    desc: lamp.desc,
                    code: lamp.order_code,
                    type: lamp.lamp_type,
                    cent_type: lamp.cu_type,
                    cent_id: lamp.cu_id
                });
            }


            doc.autoTable({
                columns,
                body: rows,                      
                startY: 28,
                theme: 'striped',
                styles: {
                        fontSize: 7,
                        //font: "helvetica", // helvetica, times, courier
                        font: 'Roboto',
                        fontStyle: 'normal', // normal, bold, italic, bolditalic
                        halign: 'left', // left, center, right
                },
                headStyles: {},
                bodyStyles: {},
                alternateRowStyles: {},
                columnStyles: {}
            });


            doc.save("plant_export_" + self.currentAmbiente.name + ".pdf");

            // }
        },
        getMappeLamp(lamp) {
            if (this.ambienti == null || this.ambienti.length == 0) return "";
            var mappe = "";
            for (var a = 0; a < this.ambienti.length; a++) {
                var amb = this.ambienti[a];
                if (amb.lamps != null && amb.lamps.length > 0){
                    for (var l=0; l<amb.lamps.length; l++) {
                        var ll = amb.lamps[l];
                        if (ll.id == lamp.id) {
                            mappe += ", " + amb.name
                        }
                    }
                }
            }
            if (mappe.length > 2) return mappe.substr(2);
            return mappe;
        },
        filtraLampadeLibere(value) {
            this.filtroLampadeLibere=value;
            this.$nextTick(() => {
                console.log("filtro lampade libere:" , this.filtroLampadeLibere);
            });

        },
        evidenzia() {
            
            if (this.highlightedLamp != "" && this.highlightedLamp.length == 4) {
                console.log("evidenzio " + this.highlightedLamp);
            }
        },
        zooming(srcObj) {
            var lamps = this.currentAmbiente.lamps;
            let tr = srcObj.getTransform();
            console.log("zooming=" + tr.scale, tr);
            if (lamps != null && lamps.length > 0) {
                for (var l=0; l<lamps.length; l++) {
                    var lamp = lamps[l];
                    //console.log("lampInfo:",lamp);
                    var lampDiv = document.getElementById("dot"+lamp.id);
                    //console.log("lampDiv=",lampDiv, lampDiv.getBoundingClientRect());
                    let bgElem = document.getElementById("imgBig");
                    //console.log("bgImg = " + bgElem.clientWidth + "x" + bgElem.clientHeight);

                    var newX = lamp.px * bgElem.clientWidth * tr.scale / 100.0 - 32 + tr.x;
                    var newY = lamp.py * bgElem.clientHeight * tr.scale / 100.0 - 32 + tr.y;
                    //console.log("newx="+newX+",newY="+newY);
                    lampDiv.style.left = newX+"px";
                    lampDiv.style.top = newY+"px";
                }
            }
        },

        findLamp(id) {
            //console.log("ricerca lampada per mappa, id:",id);
            var lamp = null;
            if (this.$store.getters.isBluetooth && this.zonesDetails != null)
            {
                var trovato = false;
                this.zonesDetails.some(function (z) {
                    z.bleLamps.some(function (l) {
                        if (l.id == id)
                        {
                            lamp = l.lamp;
                            lamp.id = id;
                            lamp.zoneName = z.zoneName;
                            lamp.device_function = lamp.autonomy.includes("H") ? "EMERGENZA" : "ILLUMINAZIONE";
                            trovato = true;
                        }
                        return trovato;
                    });
                    return trovato;
                });            
            } else {

                if (this.unitsDetails == null) return null;

                this.unitsDetails.some(u => {
                    let candidateArrays = [];
                    
                    if (u.cu_type === "sicuro") {
                        // Flatten the nested lamps from ak and ak_ext
                        candidateArrays = [
                            ...(u.ak || []).flatMap(ak_item => (ak_item.lines || []).flatMap(line => line.lamps || [])),
                            ...(u.ak_ext || []).flatMap(ak_item => (ak_item.lines || []).flatMap(line => line.lamps || []))
                        ];
                        
                    } else {
                        // Concatenate all direct lamp/sensor arrays
                        candidateArrays = [
                            ...(u.lamps || []),
                            ...(u.lamps_illum || []),
                            ...(u.sensors || [])
                        ];
                    }

                    //console.log("Searching in unit:", u.cu_id, "Candidate lamps/sensors:", candidateArrays);
                    // Search the combined array for the lamp ID
                    const foundLamp = candidateArrays.find(l => l.lamp_id === id || l.id === id);
                    
                    if (foundLamp) {
                        lamp = foundLamp;
                        return true; // Stop the outer unitsDetails.some() loop
                    }
                    return false;
                });
            }
            
            //console.log("lamp found for map: ",lamp);
            return lamp;
        },
        findCu(id) {
            var cu = null;
            if (this.unitsDetails == null) return null;
            this.unitsDetails.forEach(function(u){
                    if (u.cu_id == id) 
                    {
                        cu=u;
                        cu.device_function="CU";
                    }        
               })   
            return cu;
        },
        // mostraPaginaCentrali() {
        //     this.$router.push({name: 'Centrali', params: {pid: this.$store.state.currentPlant.id}})
        // },
        // mostraPaginaTuttiDispositivi() {
        //     this.$router.push({name: 'TuttiDispositivi', params: {pid: this.$store.state.currentPlant.id}})
        // },
        // mostraPaginaPlanimetrie() {
        //     this.$router.push({name: 'Planimetrie', params: {pid: this.$store.state.currentPlant.id}})
        // },
        // mostraPaginaAmbienti() {
        //     this.$router.push({name: 'Ambienti', params: {pid: this.$store.state.currentPlant.id}})
        // },
        // mostraPaginaZone() {
        //     this.$router.push({name: 'Zone', params: {pid: this.$store.state.currentPlant.id}})
        // },
        apertoDettaglioMappa() {
            console.log("Aperto dettaglio " + this.currentAmbiente.isNew);
            this.tabIndex = 0;
            this.selectedLamp = null;
            if (this.currentAmbiente.isNew) {
                this.showDropZone = true;

            }
        },
        showModalDisclaimer()
        {
            var acceptedDate= new Date(this.$store.state.user.disclaimerPhotoAccepted);
            if (acceptedDate.getFullYear()>2019 && acceptedDate.getFullYear()<2200)
            {
                console.log("DisclaimerPhoto già accettata in data",acceptedDate);
                this.aggiungiPianta();
            }
            else
            {
                this.$refs['modalDisclaimerPhoto'].show();
            }    
        },
        accettazioneDisclaimerPhoto()
        {
           var actualDate=new Date();
           console.log("Dispatch accettazione disclaimer",actualDate);
           this.$store.dispatch('dbSaveDisclaimerPhoto',{acceptedDate: actualDate});
        },
        aggiungiPianta() {

            const plant = this.$store.state.currentPlant;
            var mappe = plant[this.section];
            let numMappe = (mappe == null) ? 0 : mappe.length;
            if (this.$store.getters.isProExpired) {

                if (numMappe >= this.$store.state.appConfig.maxPlants) {
                    this.$bvModal.msgBoxConfirm("Funzionalità PRO Scadute. Per ripristinare le funzionalità rinnova il servizio PRO.", {
                        title: 'Limite ' + this.section + ' raggiunto',
                        okVariant: 'success',
                        okTitle: 'Rinnova PRO',
                        cancelTitle: 'CHIUDI',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                        //this.$root.$emit('openSettingsEvent');
                        this.$router.push({
                            name: "GeneraliImpianto",
                            params: { plantId: this.$store.state.currentPlant.id }
                        });
                        }
                    });
                    return;
                }


            }


            if (plant.plant_type == 'basic') {
                if (numMappe >= this.$store.state.appConfig.maxPlants) {
                    var msg = (this.$store.state.appConfig.maxPlants > 0) ? "Su impianti Basic è possibile configurare un massimo di " + this.$store.state.appConfig.maxPlants + " " + this.section : "Funzionalità disponibile solo su impianti PRO";

                    this.$bvModal.msgBoxConfirm(msg, {
                        title: 'Limite ' + this.section + ' raggiunto',
                        okVariant: 'success',
                        okTitle: 'Passa a PRO',
                        cancelTitle: 'CHIUDI',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                        //this.$root.$emit('openSettingsEvent');
                        this.$router.push({
                            name: "GeneraliImpianto",
                            params: { plantId: this.$store.state.currentPlant.id }
                        });
                        }
                    });
                    return;
                }
            }

            const pianta = {
                id: parseInt(Math.random() * 10000),
                name: "",
                lamps: [],
                isNew: true 
            };
            
            if (mappe == null)  {
                Vue.set(this.$store.state.currentPlant,this.section,[]);
                mappe = this.$store.state.currentPlant[this.section];
            }
            mappe.push(pianta);
            this.imgUploaded = false;
            this.apriModal(mappe.length-1);

        },
        picReady(id) {
            //console.log("picReady " + id, this.picLoaded);
            Vue.set(this.picLoaded,'pic'+id,id);
            //this.$forceUpdate();
        },
        eliminaAmbiente(ambiente,index) {
            const self = this;
            this.$bvModal.msgBoxConfirm('Sicuro di vole eliminare questa pianta?', {
                    title: 'Attenzione!',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'ELIMINA',
                    cancelTitle: 'ANNULLA',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    console.log("risposto con:" + value);
                    if (value) {
                        self.$store.state.currentPlant[self.section].splice(index,1);
                        self.$store.dispatch("aggiornaMappePost",{plantId: self.plantDetails.id, mapType: self.section, maps: self.$store.state.currentPlant[self.section]});
                    }
                });
        },
        chiudiNoSave()
        {
            this.$bvModal.hide('modal-ambiente');
        },
        //-------------------------------------------------------------
        // Funzione chiamata alla chiusura del dettaglio mappa
        // prevede il salvataggio delle modifiche
        //-------------------------------------------------------------
        salvachiudiDettaglioMappa(ev) {
            console.log("chiuso dettaglio mappa", ev);

            const self = this;
            if (this.currentAmbiente == null) return;
            if (this.currentAmbiente.name.trim() == '') {
                ev.preventDefault();
                this.$bvModal.msgBoxConfirm(this.$t('scenario.warning_zone'), {
                    title: this.$t('scenario.warning'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'OK',
                    cancelTitle: this.$t('scenario.close').toUpperCase(),
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    console.log("risposto con:" + value);
                    if (! value) {
                        //chiudo la modale ed elimino l'ambiente aggiunto
                        self.$store.state.currentPlant[self.section].pop();
                        self.currentAmbiente = null;
                        self.$bvModal.hide('modal-ambiente');
                        self.$forceUpdate();
                    }
                })
                return;
            }
            //salvo le modifiche
            this.handleModalSave(this.currentAmbiente);

            var mappe = this.plantDetails[this.section];
            console.log("mappe:", mappe);
            mappe.forEach(function(m) {
                m.isNew = false;
            });

            this.currentAmbiente.isNew = false;

            const indexMap = mappe.findIndex(m => m.id === this.currentAmbiente.id);
            const mappa = this.plantDetails[this.section][indexMap];          

            //invia aggiornamento al backend
            //this.$store.dispatch("aggiornaMappePost",{plantId: this.plantDetails.id, mapType: this.section, maps: mappe});
            console.log("salva singola mappa", this.currentAmbiente);
            const cmdData = {
                plantId: this.plantDetails.id,
                mapType: this.section,
                map: mappa,
                index: indexMap
            };
            console.log("cmdData:", cmdData);
            this.$store.dispatch("aggiornaSingolaMappaPost",cmdData);

            // Reset lamp positions before closing
 
            this.resetZoomToZero();
            self.$bvModal.hide('modal-ambiente');
        },


        //--------------------------------------------------------------------------------
        // Funzione chiamata alla chiusura del dettaglio mappa tramite bottone X
        // prevede richiesta conferma della chiusura senza il salvataggio delle modifiche
        //--------------------------------------------------------------------------------
        chiudiDettaglioMappa() {
            const self = this;
            this.$bvModal.msgBoxConfirm(this.$t('scenario.close_not_saved'), {
                title: this.$t('scenario.warning'),
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'OK',
                cancelTitle: this.$t('cancel'),
                footerClass: 'p-2',
                hideHeaderClose: true,
                centered: true
            })
            .then(value => {
                console.log("risposto con:" + value);
                if (value) {
                    // Reset lamp positions before closing
                    this.resetZoomToZero();
                    //chiudo la modale
                    self.$bvModal.hide('modal-ambiente');
                }
            })
        },
        stateDesc: function(value) {
            if (this.hasError(value)) 
                return this.$t('planimetry.lamp_error');
            return this.$t('planimetry.lamp_ok');
        },
        hasError: function(lampDet) {
            if(lampDet.error_batt_short == 'ON' 
            || lampDet.error_hardware == 'ON' 
            || lampDet.error_batt_test == 'ON' 
            || lampDet.error_com_radio_lamp == 'ON' 
            || lampDet.error_led == 'ON' 
            || lampDet.error_tubo_UV == 'ON'
            || lampDet.error_overpower == 'ON'
            || lampDet.error_underpower == 'ON'
            || lampDet.error_overvoltage == 'ON'
            || lampDet.error_undervoltage == 'ON'
            || lampDet.errorBallastCom == 'ON'
            || lampDet.lampFail == 'ON'          
            || lampDet.error_com_ak_lamp == 'ON'
            || lampDet.error_id_duplicate == 'ON'
            || lampDet.error_lamp_programming == 'ON'
            || lampDet.error_led_full_short == 'ON'
            || lampDet.error_led_open =='ON'
            || lampDet.error_led_partial_short == 'ON'
            || lampDet.error_polarity_reverse == 'ON'
            || lampDet.error_under_threshold == 'ON'    
            )
                return true;
            else
                return false;
        },
        hasErrorCom: function(lampDet) {
            if(lampDet.error_com == 'ON')
                return true;
            else
                return false;
        },
        hasOrphan: function(lampDet) {
            if(lampDet.nodo_orfano==true)
                return true;
            else
                return false;
        },
        isInEmergency: function(lampDet) {
            if(lampDet.emer_active == 'EMERGENZA IN CORSO')
                return true;
            else
                return false;
        },
        tipoLamp: function(lamp) {
            if(lamp.device_function=="EMERGENZA" || lamp.device_function=="ILLUMINAZIONE" || lamp.device_function=="ALTRO" || lamp.device_function=="CU")
                return (lamp.device_function ).toLowerCase();
            else
                return ("emergenza");
        },
        showModalRimuoviLampada(lamp) {
            this.lampToRemove=lamp;
            this.$refs['modalRemoveLamp'].show();
        },
        rimuoviLampada(lamp) {
            this.selectedLamp=null;
            for (var i=0; i< this.currentAmbiente.lamps.length; i++) {
                if (this.currentAmbiente.lamps[i].id == lamp.id) {
                    this.currentAmbiente.lamps.splice(i,1);
                    break;
                }
            }
        },
        dragLamp(lamp,index,ev) {
            console.log("dragStart",lamp,index,ev,this.tipoLamp(lamp));
            this.draggedLamp = lamp;           
            console.log("dragged Lamp in drag",this.draggedLamp);
            var tipo = this.tipoLamp(lamp);
            var img = document.createElement("img");
            img.src = '/img/dot_drag_' + tipo.toLowerCase() + '.png';
            img.style.width = "32px";
            img.style.height = "32px";
            ev.dataTransfer.setDragImage(img,16,16);
        },
        highlightLamp(lamp,index) {
            console.log("highlight",lamp,index,this.currentAmbiente.lamps)
            if (lamp.alreadyAdded) {
                var selLamp = this.currentAmbiente.lamps.filter(function(l) {
                    return l.id == lamp.id;
                })
                if (selLamp != null) {
                    this.selLampDot(selLamp[0],-1);
                }
            }
        },
        dropLamp(lamp,index,ev) {
            ev.preventDefault();
            console.log("drop!", ev, lamp);
            

            if (this.draggedLamp != null) {
                
                const w = ev.target.offsetWidth;
                const h = ev.target.offsetHeight;
                const px = ev.offsetX * 100 / w;
                const py = ev.offsetY * 100 / h;
                
                var status_dragged="";
                var tipo = this.tipoLamp(this.draggedLamp);

                console.log("dragged Lamp in drop", this.draggedLamp, tipo);  

                if (tipo == "emergenza") {
                    if(this.draggedLamp.nodo_orfano==true)
                        status_dragged="orphan";    
                    else if(this.draggedLamp.error_batt_short=="OFF" && this.draggedLamp.error_batt_test=="OFF" && this.draggedLamp.error_com=="OFF" && this.draggedLamp.error_hardware=="OFF" && this.draggedLamp.error_led=="OFF")
                        status_dragged="ok";
                    else
                        status_dragged="err";
                } else {
                    if(this.draggedLamp.nodo_orfano==true)
                        status_dragged="orphan";  
                    else if(this.draggedLamp.error_com=="OFF" && this.draggedLamp.error_hardware=="OFF" && this.draggedLamp.error_led=="OFF")
                        status_dragged="ok";
                    else
                        status_dragged="err";
                }

                console.log("dragged lamp: ", this.draggedLamp.id, status_dragged, px, py,tipo);

                this.currentAmbiente.lamps.push(
                    {
                        id: this.draggedLamp.id,
                        status: status_dragged,
                        px: px,
                        py: py,
                        selected: false,
                        tipo: tipo
                    }
                )

                console.log("dragged ambient: ", this.currentAmbiente);

                this.draggedLamp = null;
            }

        },
        bigImgLoaded() {
            const elem = document.getElementById("imgBig");
            if (elem == null) return;
            console.log("image loaded " + elem.src);

            //rimuovi filtri lampade non assegnate nei tab 0 e 1 (da usare solo nel tab 2)
            console.log("tabIndex",this.tabIndex);
            if(this.tabIndex!=2) 
            {
                this.filtroLampadeLibere=false;
                this.filtro="";
            }

            if (elem.src.indexOf('empty_map') > 0) return;
            this.imgLoaded = true;
        },
        closeDropZone() {
            this.showDropZone = false;
            this.$refs.myVueDropzone.removeAllFiles();
        },
        uploadImg() {
            console.log("upload img")
            this.showDropZone = true
        },
        imageUrl(ambid) {
            if (this.currentAmbiente != null && this.currentAmbiente.id == ambid) {
                console.log("imageUrl, isNew=" + this.currentAmbiente.isNew + "," + this.imgUploaded + ", path=" + this.pathMapImages + "img/" + this.section +"/" + this.plantId + '-' + ambid + '.jpg');
                if (this.currentAmbiente.isNew && !this.imgUploaded) {
                    return "/img/empty_map.jpg";
                }
            }
            return this.pathMapImages + "img/" + this.section +"/" + this.plantId + '-' + ambid + '.jpg'; 
        },
        sendingImage(file,xhr,formData) {
            console.log("sendingImage",file,xhr,formData);
            console.log(file.type, file.dataURL);
            const buf = Buffer.from(file);
            console.log(buf.toString('base64'));
            //xhr.setRequestHeader("Content-Type","application/json")
        },
        fileAdded(file) {
            console.log("file added",file);
            const self = this;
            const reader = new FileReader();
            reader.onloadend = function(result) {
                console.log("result:",result);
                self.axios.post('', {
                    action: 'uploadImage',
                    plantId: self.plantDetails.id,
                    type: self.section,
                    resId: self.currentAmbiente.id,
                    data: result.target.result
                })
                    .then(function (response) {
                        console.log("post eseguita",response);
                        self.$nextTick(() => {
                            self.showDropZone = false;
                            self.$refs.myVueDropzone.removeAllFiles();
                            self.imgUploaded = true;
                            self.$forceUpdate();
                        });
                    })
                    .catch(function (error) {
                        console.log("errore post",error);
                    });


            }
            reader.readAsDataURL(file);

        },
        mdown(obj,index, ev) {
            console.log("mdown",obj, ev)
            if (obj != null) {
                this.selLampDot(obj,-1);
                if (this.tabIndex != 2) return;
                this.dragging = true;
                this.dragStartEv = ev
                this.drgX = 0 + ev.srcElement.offsetLeft
                this.drgY = 0 + ev.srcElement.offsetTop
                console.log("startX=" + this.drgX+", startY=" + this.drgY)
            } 
            //this.dragging = true;
            //this.dragStartEv = ev
            //this.selLampDot(obj,-1);
        },
        mmove(ev) {
            
            if (!this.dragging) return
            //console.log("move " + this.dragging,ev)
            //console.log("move",ev)
            ev.preventDefault();
            let draggedEl = document.getElementById("dragged")
            if (draggedEl != null) {
                draggedEl.style.visibility = 'visible'
                draggedEl.style.left = (ev.clientX - this.dragStartEv.clientX + this.drgX)+'px'
                draggedEl.style.top = (ev.clientY-this.dragStartEv.clientY + this.drgY)+'px'
            }
        },
        mup(ev) {
            //console.log("mup",ev)
            if (this.dragging && this.dragStartEv != null) {
                let elem = document.getElementById("imgBig");
                let w = elem.clientWidth;
                let h = elem.clientHeight;

                // var trX = 0.0;
                // var trY = 0.0;
                var scale = 1.0

                var zoomC = this.$refs.zoomContainer;
                //console.log("zoomC",zoomC);
                if (zoomC != null) {
                    var panZoomObj = zoomC.$panZoomInstance;
                    //console.log("panZoomInstance",panZoomObj);
                    var tr = panZoomObj.getTransform();
                    // trX = tr.x;
                    // trY = tr.y;
                    scale = tr.scale;
                }

                let draggedEl = document.getElementById("dragged")
                draggedEl.style.visibility = "hidden"
                
                let dx = (ev.clientX - this.dragStartEv.clientX) * 100 / w /scale
                let dy = (ev.clientY - this.dragStartEv.clientY) * 100 / h /scale
                console.log("dx=" + dx + ", dy=" + dy)
                let obj = this.selectedLamp
                var newX = Math.min(100,Math.max(0,obj.px + dx));
                var newY = Math.min(100,Math.max(0,obj.py + dy));
                obj.px = newX;
                obj.py = newY;
            }
            this.dragging = false
            this.dragStartEv = null;
        },
        dragX(ev) {
            //console.log("drag!",ev);
            let dx = ev.screenX - this.dragStartEv.screenX
            let dy = ev.screenY - this.dragStartEv.screenY
            console.log("dx=" + dx + ", dy=" + dy);
        },
        dragstartX(obj, ev) {
            console.log("drag start! " + obj.id, ev)
            this.dragging = true;
            this.dragStartEv = ev;
            return true;
        },
        dragendX(obj,ev) {
            console.log("drag end! " + obj.id, ev)
            this.dragging = false;
            let elem = document.getElementById("imgBig");
            let w = elem.clientWidth;
            let h = elem.clientHeight;
            
            let dx = ev.offsetX * 100.0 / w;
            let dy = ev.offsetY * 100.0 / h;
            var newX = Math.min(100,Math.max(0,obj.px + dx));
            var newY = Math.min(100,Math.max(0,obj.py + dy));
            console.log("px=" + obj.px + ", py=" + obj.py + ", dx=" + dx + ", dy=" + dy+", newx=" + newX+", newY=" + newY);
            
            obj.px = newX;
            obj.py = newY;

            /*this.dragging = false;
            if (dragElem != null) {
                //console.log("pos:",dragElem.offsetLeft, dragElem.offsetWidth)
                let px = Math.min((dragElem.offsetLeft + 32) * 100.0 / w, 100); 
                let py = Math.min((dragElem.offsetTop + 32) * 100.0 / h, 100);
                //console.log("percentuale " + obj.id+" - " + dragElem.offsetLeft+" => px=" + px + ", " + dragElem.offsetTop + " => py=" + py)
                obj.px = px;
                obj.py = py;
            }*/

            return true;
        },
        startLampDragX(obj,ev) {
            console.log("startLampDrag",obj,ev)
            this.selLampDot(obj,-1);
            this.dragging = true;
        },
        endLampDragX(obj,index) {
            if (!this.dragging) return;
            console.log("endLampDrag",obj,index);
            let dragElem = document.getElementById("dit"+index);
            //console.log("element:",dragElem);
            let elem = document.getElementById("imgBig");
            let w = elem.clientWidth;
            let h = elem.clientHeight;
            this.dragging = false;
            if (dragElem != null) {
                //console.log("pos:",dragElem.offsetLeft, dragElem.offsetWidth)
                let px = Math.min((dragElem.offsetLeft + 32) * 100.0 / w, 100); 
                let py = Math.min((dragElem.offsetTop + 32) * 100.0 / h, 100);
                //console.log("percentuale " + obj.id+" - " + dragElem.offsetLeft+" => px=" + px + ", " + dragElem.offsetTop + " => py=" + py)
                obj.px = px;
                obj.py = py;
            }
        },
        selLampDot(obj, index) {
            console.log("sel lamp dot:" + index, obj);
            if (this.selectedLamp != null) {
                this.selectedLamp.selected = false;
            }
            obj.selected = true;
            this.selectedLamp = obj

            var elem = null;
            if (this.tabIndex == 2) {
                elem = document.getElementById('lamprow-'+obj.id);
                if(elem !=null)
                {
                 elem.scrollIntoView();
                }
            } else if (this.tabIndex == 1) {
                elem = document.getElementById('lrow-'+obj.id);
                elem.scrollIntoView();
            }

        },
        lampInfo(ambientIndex,lampIndex) {
            let lampInfo = this.ambienti[ambientIndex].lamps[lampIndex];
            return lampInfo;
        },
        pos(index,lampInfo) {
            //console.log("calcolo pos per " + lampInfo.id +", index " + index+", ambid="+ambid+", piloaded:" + this.picLoaded['pic'+ambid]);
            
            var trX = 0.0;
            var trY = 0.0;
            var scale = 1.0

            var zoomC = this.$refs.zoomContainer;
            //console.log("zoomC",zoomC);
            if (zoomC != null) {
                var panZoomObj = zoomC.$panZoomInstance;
                //console.log("panZoomInstance",panZoomObj);
                var tr = panZoomObj.getTransform();
                trX = tr.x;
                trY = tr.y;
                scale = tr.scale;
            }

            
            var elem = null;
            var delta = 8;
            // var dotSize = 16;

            if (index <0) {
                elem = document.getElementById("imgBig");
                delta = 32;
                // dotSize = 64;
            } else {
                elem = document.getElementById("imgDiv"+index);
            }

            if (lampInfo.id == this.highlightedLamp.toUpperCase()) {
                delta = 32;
            }

            if (elem == null) return {x: '0px', y:'0px'};
            let w = elem.clientWidth;
            let h = elem.clientHeight;
            //console.log("lamp.px=" + lampInfo.px+", lamp.py=" + lampInfo.py+" img=" + w + "x" + h);
            let px = lampInfo.px * w * scale / 100 - delta + trX;
            let py = lampInfo.py * h * scale / 100 - delta + trY;
            //console.log("calcolato " + lampInfo.id + " - px="+px+", py="+py);
            return {x: px+'px', y: py+'px'};
        },
        handleResize() {
            this.$forceUpdate();
        },
        //----------------------------------------------------------------------------------------
        // Funzione che apre la modale di dettaglio ambiente, passando una deep copy dell'oggetto
        //----------------------------------------------------------------------------------------
        apriModal(index) {
            console.log("apro modal " + index);
            console.log("lamps on maps " + this.lampsOnMap);
            this.tipiLampade="";
            this.filtro="";

            if (this.$store.getters.isProExpired) return;
            //creo la deep copy dell'ambiente
            this.currentAmbiente = JSON.parse(JSON.stringify(this.ambienti[index]));
            //this.currentAmbiente = this.ambienti[index];
            
            let self = this;
            this.imgLoaded = false;
            window.setTimeout(function() {
                self.$bvModal.show('modal-ambiente');
                //self.$forceUpdate();
            }, 100);
        },
        //----------------------------------------------------------------------------------------------
        // Funzione che salva in store.js le modifiche apportate all'ambiente, in modo che poi, tramite
        // la reaction di Vuex, vengano aggiornate anche le variabili locali di AmbientiPlanimetrie.vue
        //----------------------------------------------------------------------------------------------
        handleModalSave(modifiedAmbiente) {            
            // Find the index of the original object
            const index = this.plantDetails[this.section].findIndex(a => a.id === modifiedAmbiente.id);
            //devo ricostruire la struttura di currentPlant con l'ambiente modificato
            const plantModified = JSON.parse(JSON.stringify(this.plantDetails));
            plantModified[this.section][index] = modifiedAmbiente;
            this.$store.commit('setPlantDetails', plantModified);
        }
    }
}
</script>

<style lang="scss">
.modal-fullscreen .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 100000;
}

.nopad {
       padding: 0;
    }
    .imgDiv {
        position: relative;
    }

    .dotImg {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 13px;
        height: 13px;
        
    }

    @keyframes highlightedDotAnim {
        0% {background-color: rgba(255,255,255,0);}
        50% {background-color: rgba(255,255,0,0.8);}
        100% {background-color: rgba(255,255,255,0);}
    }

    .dotImgHighlight {
        background-color: #ffff00;
        width: 61px;
        height: 61px;
        padding: 24px;
        border-radius: 32px;
        animation-name: highlightedDotAnim;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }

    .dotImgEmergency {
        background-color: orange;
        width:  15px;
        height: 15px;
        padding: 3px;
        border-radius: 32px;
    }

    .dotImgBigEmergency {
        background-image: radial-gradient(orange,transparent) !important;
        padding: 15px !important;
        border-radius: 32px !important;
    }

    
    .dotImgBig {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 50px;
        height: 50px;
        padding: 16px;
        background-color: #ffffff11;
        border-radius: 12px;
        z-index: 10000;
    }

    .dotSel {
        background-color: #00990044;
    }

    .modal-xl {
        max-width: 95%;
    }
    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }

    #dropzoneContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
        top: 0;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px;
        z-index: 11000;
    }
    #dropzone {
        height: 100%;
    }
    .draggableRow {
        cursor: pointer;
    }
    .lampUsed {
        background-color: #ffff;
    }

    .highlightedRow {
        background-color: #b3d3ec;
    }
   
    .highlightedAdded {
        background-color: #ffff;
    }
    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    #modal-ambiente .modal-content {
        min-height: 600px;
    }

</style>